import React from "react";
import ReactCountryFlag from "react-country-flag";

function FlagIcon({ countryCode = "EN" }) {
  return (
    <React.Fragment>
      {/* Renders as an emoji by default */}
      {/* <ReactCountryFlag countryCode={countryCode} /> */}

      {/* Renders as an SVG, with custom styles */}
      <ReactCountryFlag
        svg
        countryCode={countryCode}
        style={{
          width: "1.5em",
          height: "1.5em",
        }}
      />
    </React.Fragment>
  );
}

export default FlagIcon;
